import styled from 'styled-components';
import {
  COLOR_BORDER_GRAY,
  COLOR_BACKGROUND_GRAY,
  screen,
} from '../../../common/variables';

export const Wrapper = styled.div`
  @media ${screen.largeXL} {
    border: 1px solid ${COLOR_BORDER_GRAY};
  }
  padding: 10px;

  .stream-selector-mobile {
    .select-container {
      margin-bottom: 30px;
      @media ${screen.medium} {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
      }

      .stream-select {
        display: block;
        padding: 5px 10px;
        font-size: 15px;
        width: 100%;
        @media ${screen.medium} {
          width: auto;
        }
      }
    }

    .select-subcontainer {
      margin: 20px 20px 0px 20px;
      position: relative;
    }

    .selected-view {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      padding-bottom: 20px;
      /* padding-left: 35px;
      padding-right: 35px; */
      margin-top: 20px;
      margin-left: auto;
      margin-right: auto;
      border-bottom: 1px solid gray;
      width: 90%;

      .text-container {
        font-size: 17px;
        font-weight: 300;
        padding-top: 5px;

        .product-code {
          color: #7aa555;
          font-weight: 400;
          font-size: 20px;
        }
      }
    }
  }

  .remove-all-filters {
    color: #808080;
    border-bottom: 1px solid #808080;
    padding-bottom: 2px;
    /* width: fit-content; */
    margin: 24px;
    width: unset;
    height: 1.4rem;
    &:hover {
      cursor: pointer;
      transition: 0.3s ease-in-out;
      color: #69ad3f;
      border-color: #69ad3f;
    }
  }

  .text-result {
    margin: 20px 14px;
    font-size: 11px;
    text-align: left;
    width: 90%;

    span {
      color: #000;
      font-weight: 400;
    }
  }
`;
export const TableContainer = styled.div`
  select {
    color: gray;
    font-size: 15px;

    @media ${screen.medium} {
      width: auto;
      min-width: 100px;
      flex: 1 0 50%;
    }
  }
  background-color: ${COLOR_BACKGROUND_GRAY};
  padding: 36px;
  overflow-x: auto;
  font-size: 14px;
  td,
  th {
    text-align: left !important;
  }

  .table-head-titles {
    th {
      padding: 0 20px 0 20px;
      p {
        font-weight: 400;
      }
    }
  }

  tr:nth-child(even):not(:first-of-type) {
    background: #fff;
  }
  .pagination-arrow {
    width: 15px !important;
    height: 13px !important;
    margin: 0px 1px;
    padding: 3px;
    &:hover {
      cursor: pointer;
    }
  }
  .pagination-container {
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;
    margin: 20px;
    color: grey;
  }

  .pagination-side {
    display: flex;
    width: 20%;
    flex-direction: row;
    font-size: 15px;
    justify-content: space-around;
  }
  .pagination-left {
    display: inline-flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
  }
  .pagination-right {
    display: inline-flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    justify-content: flex-start;
  }

  .page-tracker-text {
    font-size: 12px;
    display: inline;
    background-color: #fff;
    padding: 3px 11px;
    margin: 0 13px;
    border: 1px solid darkgrey;
  }
`;

export const Table = styled.table`
  width: 100%;
  *.inline-picker-svg svg {
    fill: #676886 !important;
    width: 100%;
    max-width: 30px;
    height: 30px;
  }
  /* only show the inner border */
  border-collapse: collapse;
  th {
    font-weight: 400;
    color: grey;
    padding: 20px 20px;
  }
  td {
    padding: 3px 15px;
    font-size: 14px;
    color: gray;
  }
  tr {
    height: 40px;
  }
  td,
  th {
    border: 1px solid #e7e7e7;
    /* min-width: 134px; */
    box-sizing: border-box;
    text-align: center;
    &.heading-long {
      /* width: 100%; */
      width: 163px;
    }

    &.filter {
      position: relative;
    }
    & select {
      padding: 5px;
    }
  }
  tr:first-child th {
    border-top: 0;
  }
  tr:last-child td {
    border-bottom: 0;
  }
  tr td:first-child,
  tr th:first-child {
    border-left: 0;
  }
  tr td:last-child,
  tr th:last-child {
    border-right: 0;
  }

  .heading-table {
    position: relative;
  }

  .product-code {
    color: rgb(105, 173, 63);
    font-weight: 400;
  }

  .colour-result-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  .stream-result-container {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: max-content;
    border-radius: 20px;

    .stream-name {
      padding: 5px;
    }

    svg {
      width: 30px;
      height: 33px;
    }
  }
`;

export const ColorCircle = styled.span`
  display: inline-block;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  border: 1px solid ${COLOR_BORDER_GRAY};
  background-color: ${(props) => props.color};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
